// removed by extract-text-webpack-plugin
module.exports = {"settings":"Settings__settings___1_Tzs","show":"Settings__show___1PANx","wrapper":"Settings__wrapper___Cu_dy","nav":"Settings__nav___3TL5y","item":"Settings__item___22pN5","label":"Settings__label___24F-c","secret":"Settings__secret___3KInY","print":"Settings__print___3_VzV","language":"Settings__language___2U887","soundOn":"Settings__soundOn___sbiQH","soundOff":"Settings__soundOff___1H6-P","signUp":"Settings__signUp___3WO0e","signIn":"Settings__signIn___1ML-Y","changePlayer":"Settings__changePlayer___2C9aO","signOut":"Settings__signOut___3s-9U","about":"Settings__about___3sP_P"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Settings/Settings.css
// module id = 868
// module chunks = 0